import { render } from "./announceDialog.vue?vue&type=template&id=7c73b5b2"
import script from "./announceDialog.vue?vue&type=script&lang=js"
export * from "./announceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__